module.exports = __webpack_public_path__ + "static/media/hot41.903a1b2b.jpg";